<template>
	<div class="app">
		<transition name="fade" mode="out-in">
			<router-view />
		</transition>
	</div>
</template>
<script >
import FingerprintJS from '@fingerprintjs/fingerprintjs'
const fpPromise = FingerprintJS.load()

export default {

	mounted() {
		(async() => {
			const fp = await fpPromise
			const result = await fp.get()
			const visitorId = result.visitorId
	  sessionStorage.setItem('machineId', visitorId)
		})()
	}
}
</script>
<style lang="scss">
@import "../../static/icon/index.css";
@import "../style/common.scss";

//防止滚动条出现导致抖动
html {
	width: 100vw;
	overflow-x: hidden;
}

body {
	font-family: $font-family-base;
	font-size: 12px;
  	font-optical-sizing: auto;
	line-height: 1.2;
	color: #333333;
	background-color: #f4f7fa !important;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
div,
span,
p,
a,
b,
strong,
li,
i,
h1,
h2,
h3,
label,
time {
	font-family: $font-family-base;
}
b, strong {
  font-weight: 600 !important;
}
.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.pp-table-tbody {
	.income {
		color: #5dc489;
	}
	.expenditure {
		color: #ff4949;
	}
}
.pp-modal-header {
	border-bottom: 0;
	padding-left: 24px;
}
.pp-modal-footer {
	border-top: 0;
}
.modalContent {
	padding-left: 8px;
}
.pp-select-dropdown {
	max-height: 170px;
}
.pp-date-picker-transfer {
	max-height: 500px;
}
.custom-tooltip {
  padding: 0 !important;
  border: 0 none !important;
}
.page-title {
  padding: $page-title-padding;
  font-family: $page-title-family;
  font-size: $page-title-font-size;
  font-weight: $page-title-font-weight;
  color: $page-title-color;
  text-transform: capitalize;
}
.x-country-dropdown {
	border: 2px solid #E9ECEE !important;
	border-radius: 12px !important;
	max-width: 98%;

	.el-cascader-panel {
		font-size: 16px !important;
		font-weight: 600;
		border-radius: 12px !important;
		.el-cascader-menu__wrap {
			height: 356px !important;
		}
		.el-cascader-menu__list {
			padding: 12px 0 !important;
		}
		.el-cascader-node {
			height: 44px !important;
			margin: 0 12px !important;
			border-radius: 8px !important;
			&:hover {
				background-color: #E9ECEE !important;
			}
		}
	}
    .popper__arrow {
		display: none !important;
	}
}
</style>
